export const useIsDomainInBlacklist = () => {

    const isDomaInBlacklist = async ( record: string ) => {
        return false;
    }

    return isDomaInBlacklist;
}